import React, { useState } from 'react'
import CreateConversationHolder from '../interact/chat/createConversationHolder'

export default function SubscriberSendMessage({ subscriber, inboxes = [], onClose }) {
    return (
        <div>
            <CreateConversationHolder inboxes={inboxes} subscriber={subscriber} inboxId={inboxes.length === 1 ? inboxes[0].id : undefined} close={onClose} created={onClose} standalone={true} />
        </div>
    )
}